<template>
    <div class="flex flex-col" :class="{'h-screen' : invoices.length > 8}">
        <div class="flex-grow overflow-auto">
            <div class="relative w-full">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50 sticky top-0">
                        <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Reference
                            </th>
                            <th scope="col"  v-if="invoice_type == 'Commission'"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Client
                            </th>
                            <th scope="col" v-if="display_related_quotes"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Quote
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Date Raised
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Date Due
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Amount
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Paid
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Amount Paid
                            </th>
                            <th scope="col" v-if="invoice_type == 'Invoice'"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Final
                            </th>
                            <th scope="col" v-if="invoice_type == 'Invoice'"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Supplier Invoices
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Status
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Sent By
                            </th>
                            <th scope="col" v-if="invoice_type == 'Invoice'"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                Service Lines
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="invoices.length > 0" v-for="(invoice, index) in invoices"
                            :key="index"
                            :class="{'bg-gray-100': index % 2, 'bg-green-100' : invoice.sent_at}"
                            class="hover:bg-gray-50 cursor-pointer">
                            <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900">
                                {{ invoice.reference }}
                                <span class="text-xs font-normal" v-if="invoice.related_invoice">
                                    <br />(credited from {{ invoice.related_invoice?.reference }})
                                </span>
                            </td>
                            <td v-if="invoice_type == 'Commission'" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {{ invoice.organisation ? invoice.organisation.name : '' }}
                            </td>
                            <td v-if="display_related_quotes && invoice.quote" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {{ invoice.quote.name }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {{ moment(invoice.invoiced_at, 'DD-MM-YYYY').format('DD MMM YYYY') }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {{ moment(invoice.due_at, 'DD-MM-YYYY').format('DD MMM YYYY') }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <span v-if="invoice_type === 'Commission'">
                                    {{ formatCurrency(invoice.amount, invoice.currency?.code ?? 'gbp', true) }}
                                </span>
                                <span v-if="invoice_type === 'Invoice' && invoice.quote">
                                    {{ formatCurrency(invoice.amount, invoice.quote.sell_currency.code, true) }}
                                </span>
                                <span v-if="invoice_type == 'Management Fee'">
                                    <span v-if="invoice.currency">
                                        {{ formatCurrency(invoice.original_amount || invoice.amount, invoice.currency.code, true) }}
                                    </span>
                                    <span v-else>
                                        {{ invoice.original_amount || invoice.amount }}
                                    </span>
                                </span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <CheckIcon class="text-green-600 w-6 h-6" v-if="invoice.is_paid" />
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <span v-if="invoice_type === 'Commission'">
                                    {{ formatCurrency(invoice.amount_paid ?? 0, invoice.currency?.code ?? 'gbp', true) }}
                                </span>
                                <span v-if="invoice_type === 'Invoice' && invoice.quote">
                                    {{ formatCurrency(invoice.amount_paid ?? 0, invoice.quote.sell_currency.code, true) }}
                                </span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900" v-if="invoice_type === 'Invoice'">
                                <CheckIcon class="text-green-600 w-6 h-6" v-if="invoice.is_final" />
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900  flex justify-center items-center gap-3" v-if="invoice_type === 'Invoice'">
                                 <span class="underline text-pitch-purple text-gray-500 "
                                       @click="emitter.emit('openLinkInvoiceSlideout', invoice)">{{
                                         invoice.supplier_invoices?.length
                                     }}</span>
                                <button @click="emitter.emit('openLinkInvoiceSlideout', invoice)" type="button"
                                        class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <PlusSmIcon class="h-4 w-4 text-white" aria-hidden="true"/>
                                </button>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <span v-if="invoice.status === 'Sent'"
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white">Sent to finance</span>
                              <span v-if="invoice.status === 'Cancelled'"
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-500 text-white"> {{
                                  invoice.status
                                }} </span>
                                <span v-if="invoice.status === 'Paid'"
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800"> {{
                                        invoice.status
                                    }} </span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <span v-if="invoice.sent">
                                    <a class="flex gap-1 items-center">{{ invoice.sent.first_name + ' ' + invoice.sent.last_name + ' (' + formatDate(invoice.sent_at) + ')'  }}</a>
                                </span>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900" v-if="invoice_type == 'Invoice'">
                                <Button @click="emitter.emit('addServiceLines', invoice)" type="button"
                                      class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                     fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor" aria-hidden="true">
                                  <path stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                Open
                              </Button>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <a v-if="invoice.amount > 0 && invoice.status != 'Cancelled'" class="flex gap-1 items-center cursor-pointer hover:underline" @click="createCreditNote(invoice)" title="Create Credit Note"><CreditCardIcon class="w-4 h-4" /> Create Credit Note</a>
                                <a class="flex gap-1 items-center cursor-pointer hover:underline" :href="downloadInvoice(invoice)" title="Download Invoice"><DocumentDownloadIcon class="w-4 h-4" /> <span>Download</span></a>
                                <a class="flex gap-1 items-center cursor-pointer hover:underline" title="Add Supporting Documentation" @click="addSupportingDocumentation(invoice)"><FolderAddIcon class="w-4 h-4" /> <span>Add Supporting Documentation</span></a>
                                <a v-if="invoice.supporting_documentation != null" class="flex gap-1 items-center cursor-pointer hover:underline" :href="downloadInvoiceSupportingDocumentation(invoice)" title="Download Supporting Documentation"><DocumentDownloadIcon class="w-4 h-4" />Download Supporting Documentation</a>
                                <a v-if="!invoice.sent_at && this.invoice_type != 'Management Fee' " class="flex gap-1 items-center cursor-pointer hover:underline" @click="markInvoiceSent(invoice)" title="Mark as sent"><ArrowSmRightIcon class="w-4 h-4" /><span>Mark as Sent</span></a>
                                <a v-if="this.invoice_type == 'Management Fee'" class="flex gap-1 items-center cursor-pointer hover:underline" title="Management Fee Invoice Breakdown" @click="managementFeeInvoiceBreakdown(invoice)"><InformationCircleIcon class="w-4 h-4" /> <span>Management Fee Invoice Breakdown</span></a>
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="8"
                                class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                There are no invoices to display.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <AddSupportingDocumentation ref="slideout" />
    <CreditInvoice ref="credit_slideout" />
    <ManagementFeeInvoiceBreakdown ref="managementFeeInvoiceBreakdownSlideout" />
</template>

<script>
import moment from "moment";
import {
    CheckIcon,
    NewspaperIcon,
    CreditCardIcon,
    PencilAltIcon,
    InboxIcon,
    PlusSmIcon,
    DocumentDownloadIcon,
    FolderAddIcon,
    ArrowSmRightIcon,
    InformationCircleIcon
} from "@heroicons/vue/outline"
import {emitter} from "@/eventHub";
import Button from "@/Components/Button";
import {router, usePage} from '@inertiajs/vue3'
import CreditInvoice from "@/Components/SlideOuts/CreditInvoice";
import AddServiceLines from "@/Components/SlideOuts/AddServiceLines";
import AddSupportingDocumentation from "@/Components/SlideOuts/AddSupportingDocumentation";
import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";
import ManagementFeeInvoiceBreakdown from "@/Components/SlideOuts/ManagementFeeInvoiceBreakdown";

export default {
    components: {
        Button,
        CheckIcon,
        InboxIcon,
        PlusSmIcon,
        NewspaperIcon,
        PencilAltIcon,
        FolderAddIcon,
        ArrowSmRightIcon,
        Button,
        AddSupportingDocumentation,
        CreditInvoice,
        CreditCardIcon,
        AddServiceLines,
        DocumentDownloadIcon,
        InformationCircleIcon,
        AddSupportingDocumentation,
        LinkInvoiceToSupplierInvoice,
        ManagementFeeInvoiceBreakdown
    },
    props: {
        quote: Object,
        fixture: Object,
        invoices: Object,
        service_lines: Object,
        invoice_type: {type: String, default: "Invoice"},
        display_related_quotes: {type: Boolean, default: false}
    },
    data() {
        return {
            emitter:emitter,
            showErrors: false,
        }
    },
    created() {
        this.moment = moment
    },
    methods: {
        usePage,
        /**
         * Cancels a specified invoice
         */
        cancelInvoice (invoice) {
            // build the url depending on the invoice type
            var url = '';

            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.management-fees.cancel', [invoice.id]);
                    break
                case 'Invoice':
                    url = route('frontend.invoices.cancel', [invoice.id]);
                    break;
                case 'Commission':
                    url = route('frontend.fixture.commission.cancel', [usePage().props.fixture.id, invoice.id]);
                    break
            }

            this.$swal.fire({
                title: 'Cancel Invoice',
                html: "You are cancelling an invoice. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Delete the invoice
                        this.$inertia.get(url, {preserveScroll: true});
                    }
            });
        },
        markInvoiceSent(invoice) {
            // build the url depending on the invoice type
            var url = '';

            switch(this.invoice_type) {
                case 'Invoice':
                    url = route('frontend.invoices.send', invoice);
                    break
                case 'Commission':
                    url = route('frontend.fixture.commission.send', [usePage().props.fixture, invoice]);
                    break
            }

            this.$swal.fire({
                title: 'Mark as Sent',
                html: "Are you sure you'd like to mark this invoice as sent?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(url, {
                        preserveScroll: true,
                        preserveState: true
                    });
                }
            });

        },
        /**
         * Generates the download URL for an invoice
         */
        downloadInvoice (invoice) {
            // build the url depending on the invoice type
            var url = '';

            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.management-fees.download', [invoice.id]);
                    break
                case 'Invoice':
                    url = route('frontend.invoices.download', [invoice.id])
                    break
                case 'Commission':
                    url = route('frontend.fixture.commission.download', [usePage().props.fixture.id, invoice.id])
                    break
            }

            return url;
        },
        /**
         * Generates the download URL for an invoice's supporting documentation
         */
         downloadInvoiceSupportingDocumentation(invoice) {
            // Instantiate URL variable
            var url = '';
             
            // Build the URL depending on the invoice type
            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.invoices.managegment-invoice-supporting-documentation', [invoice.id]);
                    break;
                case 'Invoice':
                    url = route('frontend.invoices.supporting-documentation', [invoice.id])
                    break
                case 'Commission':
                    url = route('frontend.invoices.supporting-documentation', [invoice.id])
                    break
            }
            
            // Return the URL
            return url;
        },
        
        formatDate(invoiceDate) {
            var formattedDate = '';
            var formatsToCheck = ['DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD'];

            for (var i = 0; i < formatsToCheck.length; i++) {
                var format = formatsToCheck[i];
                var date = moment(invoiceDate, format, true);

                if (date.isValid()) {
                    formattedDate = date.format('DD MMM YYYY');
                    break;
                }
            }

            if (formattedDate === '') {
                formattedDate = invoiceDate;
            }

            return formattedDate;
        },
        createCreditNote(invoice) {
            this.$refs.credit_slideout.open(invoice, this.invoice_type);
        },
        /**
         * Add supporting document slideout
         */
        addSupportingDocumentation(invoice) {
            this.$refs.slideout.open(invoice, this.invoice_type);
        },
        // Management fee invoice breakdown slideout
        managementFeeInvoiceBreakdown(invoice)
        {
            this.$refs.managementFeeInvoiceBreakdownSlideout.open(invoice);
        }
    }
}
</script>
